import type { Policy, PolicyInput } from "../api/types";
import type { common } from "../i18n/common";
import type { Messages } from "../i18n/core";

type Common = Messages<(typeof common)["pt-BR"]>;

export function scheduleText(t: Common, s: Policy["schedule"]): string {
  if (s.frequency === "hourly") return t.schedule.hourly(s.time.split(":")[1] ?? "00");
  const days =
    s.weekdays.length === 7 ? t.schedule.everyDay :
    s.weekdays.join(",") === "1,2,3,4,5" ? t.schedule.weekdays :
    s.weekdays.map((d) => t.weekdaysShort[d]).join(", ");
  if (s.frequency === "weekly") return t.schedule.weekly(days, s.time, s.windowHours);
  return t.schedule.daily(days, s.time, s.windowHours);
}

export function retentionText(t: Common, r: PolicyInput["retention"]): string {
  return [
    r.daily && t.retention.daily(r.daily),
    r.weekly && t.retention.weekly(r.weekly),
    r.monthly && t.retention.monthly(r.monthly),
    r.yearly && t.retention.yearly(r.yearly),
  ].filter(Boolean).join(" · ") || t.retention.none;
}

/** Quanto tempo para trás a retenção alcança, aproximado. */
export function retentionReach(t: Common, r: PolicyInput["retention"]): string {
  if (r.yearly) return t.retention.years(r.yearly);
  if (r.monthly >= 12) {
    const y = Math.floor(r.monthly / 12);
    const m = r.monthly % 12;
    return m ? t.retention.yearsMonths(y, m) : t.retention.years(y);
  }
  if (r.monthly) return t.retention.months(r.monthly);
  if (r.weekly) return t.retention.weeks(r.weekly);
  return t.retention.days(r.daily);
}
